import { baseApi } from "./baseAPI"
import { PromotionCriteria, promotionCriteriaToQuery } from "../dtos/promotions/promotionCriteria"
import { TimelineModel } from "../dtos/timeline/timelineModel"
import { handleUrl } from "../../helpers/utils"

export const timelineAPI = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getTimelineResources: build.query<TimelineModel, PromotionCriteria>({
            query(criteria: PromotionCriteria) {
                return handleUrl("Timeline", promotionCriteriaToQuery(criteria));
            },
            // Cache by id
            providesTags: (result) => [{ type: 'TimelineResource', id: 'LIST' }],
            // transformResponse: (rawResults: Promotion[], meta) => rawResults.map(r => fixDates(r)),
        })
    }),
    overrideExisting: false,
})

export const {
    useGetTimelineResourcesQuery
} = timelineAPI
